import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
  Alert,
  IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { styled } from '@material-ui/core/styles';

const useStyles = styled((theme) => ({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  dialogContent: {
    padding: theme.spacing(3)
  },
  dialogActions: {
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`
  },
  formField: {
    marginBottom: theme.spacing(3)
  }
}));

const TemplateModal = ({ open, onClose, onSuccess }) => {
  const classes = useStyles();
  const [templateName, setTemplateName] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', severity: 'info' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ text: '', severity: 'info' });

    if (!templateName.trim()) {
      setMessage({ text: 'Template Name is required.', severity: 'error' });
      return;
    }

    setLoading(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // In a real app, you would call your API here:
      // const response = await fetch(`${baseUrl}/api/UserManagement/AddTemplate`, {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ name: templateName })
      // });
      // const data = await response.json();

      setMessage({
        text: `Template "${templateName}" added successfully!`,
        severity: 'success'
      });

      setTemplateName('');
      if (onSuccess) onSuccess();
    } catch (error) {
      setMessage({
        text: error.message || 'An error occurred.',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <h2 style={{ margin: 0 }}>Add New Template</h2>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <form onSubmit={handleSubmit}>
          <Box className={classes.formField}>
            <TextField
              label="Template Name"
              variant="outlined"
              size="small"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              fullWidth
              autoFocus
            />
          </Box>

          {message.text && (
            <Box mb={2}>
              <Alert severity={message.severity}>{message.text}</Alert>
            </Box>
          )}
        </form>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Save Template'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TemplateModal;
